import React from "react";
import { Link } from "react-scroll";
import { FaFacebookF, FaGithub, FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <div
      style={{
        borderTop: "1px solid #1e2228",
        padding: "60px 0 0",
      }}
      className="w-full grid grid-cols-1 md:grid-cols-2 lgl:grid-cols-4 gap-10"
    >
      {/* Brand */}
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div style={{
            width: "36px", height: "36px",
            borderRadius: "8px",
            background: "#ff014f",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "'JetBrains Mono', monospace",
            fontWeight: 700, fontSize: "14px", color: "#fff",
          }}>BB</div>
          <span style={{ fontFamily: "'Syne', sans-serif", fontWeight: 700, color: "#f0f2f5" }}>BIPRO</span>
        </div>
        <p style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "13px",
          lineHeight: 1.75,
          color: "#4a5568",
        }}>
          Backend & Platform Engineer building production-grade cloud systems. Open to remote opportunities.
        </p>
        <div className="flex gap-3">
          <span className="bannerIcon"><a href="https://www.facebook.com/bipro.barai.503"><FaFacebookF /></a></span>
          <span className="bannerIcon"><a href="https://github.com/bipro-b?tab=repositories"><FaGithub /></a></span>
          <span className="bannerIcon"><a href="https://www.linkedin.com/in/bipro-barai-419381179/"><FaLinkedinIn /></a></span>
        </div>
      </div>

      {/* Quick Links */}
      <div>
        <h3 style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "12px",
          color: "#ff014f",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          marginBottom: "20px",
        }}>
          // navigation
        </h3>
        <ul style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {[
            { label: "Home", to: "home" },
            { label: "Features", to: "features" },
            { label: "Projects", to: "projects" },
            { label: "Resume", to: "resume" },
            { label: "Certificates", to: "testimonial" },
            { label: "Contact", to: "contact" },
          ].map(({ label, to }) => (
            <li key={to}>
              <Link
                to={to} spy smooth offset={-70} duration={500}
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13.5px",
                  color: "#8892a4",
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={e => (e.currentTarget.style.color = "#ff014f")}
                onMouseLeave={e => (e.currentTarget.style.color = "#8892a4")}
              >
                <span style={{ color: "#4a5568", fontFamily: "'JetBrains Mono'", fontSize: "11px" }}>›</span>
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Resources */}
      <div>
        <h3 style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "12px",
          color: "#ff014f",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          marginBottom: "20px",
        }}>
          // resources
        </h3>
        <ul style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {[
            { label: "Authentication", href: "https://www.scaler.com/topics/expressjs-tutorial/authentication_and_authorization_in_express/" },
            { label: "Authorization", href: "https://www.makeuseof.com/role-based-access-control-expressjs-rest-api-passportjs-jwt/" },
            { label: "MongoDB Indexing", href: "https://www.mongodb.com/basics/database-index" },
            { label: "Aggregation Cheatsheet", href: "https://datmt.com/databases/nosql-databases/mongodb-aggregation-framework-cheat-sheet/" },
            { label: "Payment Integration", href: "https://medium.com/@kazirafi668/how-to-integrate-bkash-payment-gateway-with-react-js-and-node-js-e9777bb188d5" },
          ].map(({ label, href }) => (
            <li key={label}>
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13.5px",
                  color: "#8892a4",
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={e => (e.currentTarget.style.color = "#ff014f")}
                onMouseLeave={e => (e.currentTarget.style.color = "#8892a4")}
              >
                <span style={{ color: "#4a5568", fontFamily: "'JetBrains Mono'", fontSize: "11px" }}>›</span>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      {/* My Docs */}
      <div>
        <h3 style={{
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "12px",
          color: "#ff014f",
          letterSpacing: "0.1em",
          textTransform: "uppercase",
          marginBottom: "20px",
        }}>
          // my_docs
        </h3>
        <ul style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {[
            { label: "Render Deployment", href: "https://docs.google.com/document/d/1egdmqGV9kh6yS405_2jNYfE0BUXQLVV3hHEndr--NR0/edit" },
            { label: "Abstractions vs Encapsulation", href: "https://docs.google.com/document/d/1kDJRMyN6jack4uBCUdK6dKFsCYup7CV3YZVdMPRfCGU/edit" },
            { label: "Common Git Commands", href: "https://docs.google.com/document/d/1WykjOg5iSdmttA7A8fyQZQZFmWbAsvxtBuXMJOR_pyY/edit" },
            { label: "Design Pattern", href: "https://docs.google.com/document/d/1kDJRMyN6jack4uBCUdK6dKFsCYup7CV3YZVdMPRfCGU/edit" },
            { label: "Clean Code Architecture", href: "https://docs.google.com/document/d/1kDJRMyN6jack4uBCUdK6dKFsCYup7CV3YZVdMPRfCGU/edit" },
          ].map(({ label, href }) => (
            <li key={label}>
              <a
                href={href}
                target="_blank"
                rel="noreferrer"
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "13.5px",
                  color: "#8892a4",
                  cursor: "pointer",
                  transition: "color 0.2s ease",
                  textDecoration: "none",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={e => (e.currentTarget.style.color = "#ff014f")}
                onMouseLeave={e => (e.currentTarget.style.color = "#8892a4")}
              >
                <span style={{ color: "#4a5568", fontFamily: "'JetBrains Mono'", fontSize: "11px" }}>›</span>
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Footer;